import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { jsonAxios } from 'components/axios';
import MyPageTemplate from 'components/template/MyPageTemplate';
import CustomButton from 'components/common/CustomButton';
import { ReactComponent as Add } from 'assets/mypage/Sub/add.svg'
import ToggleSwitch from 'components/common/ToggleSwitch';
import { toast } from 'react-toastify';
import { ISubList } from 'types/user';
import { useGetUser } from 'atom/user';

const SubAccountList = () => {
    const user = useGetUser();
    const navigate = useNavigate();
    const [list, setList] = useState<ISubList[]>([]);
    const tHeader = [
        { label: "생성일", flex: 1.0 },
        { label: "아이디", flex: 2.0 },
        { label: "설정", flex: 1.0 },
    ];

    const init = useCallback(() => {
        jsonAxios.get(`sub-users`).then(res => {
            console.log(res.data)
            if (res.data.code === 200) {
                setList(res.data.data)
            }
        })
    }, []);

    useEffect(() => {
        if (user.id === undefined) return;
        if (!user.isMaster) {
            toast.error('권한이 없습니다.')
            navigate('/mypage/editProfile', { replace: true })
        }
        else {
            init();
        }
    }, [user.id, user.isMaster, init]);

    const titleStyle = () => {
        return `hidden tablet:block flex-[0.5] w-full bg-[#e5e5e5] py-1`
    }

    const tBodyStyle = () => {
        return `flex items-center justify-center py-2 text-center tablet:py-0 tablet:gap-2`
    }

    const changeStatus = (item: ISubList, value: boolean) => {
        jsonAxios.post('sub-users', { userId: item.id }).then(res => {
            if (res.data.code === 200) {
                setList((prev) =>
                    prev.map((el) =>
                        el.id === item.id ? { ...el, isActive: value } : el
                    )
                );
            }
            else {
                toast.error('상태를 변경하지 못했습니다. 관리자에게 문의해주세요.')
            }
        })
    }
    return (
        <MyPageTemplate background='bg-[#F8F8FA]'>
            <div className="flex flex-col gap-10 tablet:gap-4 mb-6 tablet:py-4 pt-10 h-full min-h-dvh">
                <div className='flex flex-col gap-6 bg-white p-10 tablet:p-4 min-h-[50vh]'>
                    <CustomButton
                        className='bg-primary w-30 !h-10 !text-sm'
                        title='계정생성'
                        Icon={Add}
                        onClick={() => {
                            navigate('/mypage/subAccount/create')
                        }}
                    />
                    <div className='flex flex-col gap-3'>
                        <div className='tablet:hidden flex bg-[#F8F8FA] font-semibold text-sm 2xl:text-base'>
                            {
                                tHeader.map((item, idx) => (
                                    <div
                                        key={idx}
                                        className={`flex-[${item.flex}] flex items-center justify-center h-15`}
                                    >
                                        {item.label}
                                    </div>
                                ))
                            }
                        </div>
                        {
                            list.length > 0 ?
                                list.map((item, idx) => (
                                    <div
                                        className={`relative flex text-sm border border-[#E1E1E8] transition-all rounded tablet:flex-col tablet:gap-1 xl:h-20 hover:bg-[#EEF4FF] cursor-pointer`}
                                        key={idx}
                                        onClick={() => {
                                            navigate('/mypage/subAccount/modify', { state: { item } })
                                        }}
                                    >
                                        <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-2`}>
                                            <p className={titleStyle()}>{tHeader[0].label}</p>
                                            <p className='flex-1'>
                                                {item.dateJoined}
                                            </p>
                                        </div>
                                        <div className={`flex-[2.0] ${tBodyStyle()} tablet:order-1`}>
                                            <p className={titleStyle()}>{tHeader[1].label}</p>
                                            <p className='flex-1'>
                                                {item.username}
                                            </p>
                                        </div>
                                        <div className={`flex-[1.0] ${tBodyStyle()} tablet:order-3`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                            }}
                                        >
                                            <p className={titleStyle()}>{tHeader[2].label}</p>
                                            <div className='flex-1'>
                                                <ToggleSwitch
                                                    isLabel={false}
                                                    checked={item.isActive}
                                                    onChange={(value) => {
                                                        changeStatus(item, value)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                <div className='flex justify-center items-center py-6 min-h-[30vh]'>
                                    데이터가 없습니다.
                                </div>
                        }
                    </div>
                </div>
            </div>
        </MyPageTemplate>
    )
}

export default SubAccountList